module.exports = __webpack_public_path__ + "img/1-9.a0f46d82.png";